// packages block
import { Avatar, Box, IconButton, Menu, MenuItem } from '@mui/material'
import { FC, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
// others block
import { PrimaryDots } from '../../assets/images'
import { ChartsOfAccountsMenuProps } from '../../interfaceTypes'
import { anchorOrigin, menuPaperStyles, transformOrigin } from '../../theme/styleConstants'

export const ChartsOfAccountsMenu: FC<ChartsOfAccountsMenuProps> = ({ currentChartOfAccount }): JSX.Element => {
  const [open, setOpen] = useState<boolean>(false)
  const { id } = currentChartOfAccount || {}
  const accountId = id || ''

  const handleClick = () => setOpen(!open)
  const handleClose = () => setOpen(false)

  const anchorRef = {
    [accountId]: useRef<HTMLButtonElement>(null)
  }

  return (
    <Box>
      <IconButton
        ref={anchorRef[accountId]}
        id={`long-button-${accountId}`}
        aria-controls={`long-menu-${accountId}`}
        aria-haspopup="true"
        onClick={handleClick}
        aria-label="show more"
      >
        <Avatar sx={{ bgcolor: 'transparent' }}>
          <PrimaryDots />
        </Avatar>
      </IconButton>

      <Menu
        id={`long-menu-${accountId}`}
        anchorEl={anchorRef[accountId].current}
        open={open}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        onClose={handleClose}
        PaperProps={menuPaperStyles}
      >
        <MenuItem component={Link} to={`/accounts/chartered/${accountId}`}>
          View Details
        </MenuItem>
      </Menu>
    </Box>
  )
}
